import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./About.css";
import Seo from "./Common/Seo";

const aboutImages = [
  { id: "about-column-1", images: [{ id: "about-1", src: "/images/resource/about-img-1.jpg" }] },
  { id: "about-column-2", images: [{ id: "about-2", src: "/images/resource/about-img-2.jpg" }, { id: "about-3", src: "/images/resource/about-img-3.jpg" }] },
  { id: "about-column-3", images: [{ id: "about-4", src: "/images/resource/about-img-4.jpg" }, { id: "about-5", src: "/images/resource/about-img-5.jpg" }] },
  { id: "about-column-4", images: [{ id: "about-6", src: "/images/resource/about-img-6.jpg" }] },
];

const funFacts = [
  { id: "job-expiry", value: "30", suffix: " Days", title: "Automatic job expiration for every paid listing" },
  { id: "payment-models", value: "2", suffix: "", title: "Flexible payment models for employers", delay: "400ms" },
  { id: "online-discovery", value: "24", suffix: "/7", title: "Job discovery and applications online", delay: "800ms" },
];

const testimonials = [
  {
    id: "brooklyn-simmons",
    image: "/images/resource/testi-thumb-1.png",
    title: "Faster hiring workflow",
    text: "Epic-Jobs gives our recruitment team one place to publish roles, track applicants, and keep job listings organized from start to finish.",
    name: "Brooklyn Simmons",
    designation: "Recruitment Lead",
  },
  {
    id: "courtney-henry",
    image: "/images/resource/testi-thumb-2.png",
    title: "Simple paid postings",
    text: "The pay-per-post option is ideal when we only need to advertise one opening, while the 12-post pack works well for ongoing hiring.",
    name: "Courtney Henry",
    designation: "HR Manager",
  },
  {
    id: "marvin-mckinney",
    image: "/images/resource/testi-thumb-3.png",
    title: "Easy for applicants",
    text: "Candidates can browse jobs, view details, and apply after logging in with a job seeker account, which keeps applications tied to the right profile.",
    name: "Marvin McKinney",
    designation: "Talent Partner",
  },
];

const workItems = [
  {
    id: "choose-access",
    image: "/images/resource/work-1.png",
    title: "Employers Choose Access",
    text: "Recruiters register, select pay-per-post or a 12-post pack, and unlock job posting access through Stripe payments.",
  },
  {
    id: "manage-jobs",
    image: "/images/resource/work-2.png",
    title: "Post And Manage Jobs",
    text: "Employers create listings, manage active roles, review applicants, and each approved job can automatically expire after 30 days.",
  },
  {
    id: "direct-apply",
    image: "/images/resource/work-3.png",
    title: "Candidates Apply Directly",
    text: "Job seekers search openings, read job details, and apply through the platform with a candidate account.",
  },
];

const clientLogos = [
  { id: "client-1", src: "/images/clients/1-1.png" },
  { id: "client-2", src: "/images/clients/1-2.png" },
  { id: "client-3", src: "/images/clients/1-3.png" },
  { id: "client-4", src: "/images/clients/1-4.png" },
  { id: "client-5", src: "/images/clients/1-5.png" },
  { id: "client-6", src: "/images/clients/1-6.png" },
  { id: "client-7", src: "/images/clients/1-7.png" },
];

const About = () => {
  return (
    <>
      <Seo title="About Epic-Jobs" description="Epic-Jobs connects employers and candidates with job posting, application, profile, and admin workflows." />
      {/* Page Title */}
      <section className="page-title">
        <div className="auto-container">
          <div className="title-outer">
            <h1>About Us</h1>
            <ul className="page-breadcrumb">
              <li><Link to="/">Home</Link></li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </section>
      {/* End Page Title */}

      {/* About Section Three */}
      <section className="about-section-three">
        <div className="auto-container">
          <div className="images-box">
            <div className="row">
              {aboutImages.map((column) => (
                <div className="column col-lg-3 col-md-6 col-sm-6" key={column.id}>
                  {column.images.map((image) => (
                    <figure className="image" key={image.id}>
                      <img src={image.src} alt="" />
                    </figure>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Fun Fact Section */}
          <div className="fun-fact-section">
            <div className="row">
              {funFacts.map((fact) => (
                <div
                  className="counter-column col-lg-4 col-md-4 col-sm-12 wow fadeInUp"
                  data-wow-delay={fact.delay}
                  key={fact.id}
                >
                  <div className="count-box">
                    <span className="count-text" data-speed="3000" data-stop={fact.value}>{fact.value}</span>{fact.suffix}
                  </div>
                  <h4 className="counter-title">{fact.title}</h4>
                </div>
              ))}
            </div>
          </div>
          {/* Fun Fact Section */}

          <div className="text-box">
            <h4>About Epic-Jobs</h4>
            <p>Epic-Jobs is a modern web-based job board platform built to connect employers, recruiters, and job seekers through a simple hiring workflow. Employers can create an account, purchase posting access, publish jobs, manage listings, and review applications from one place.</p>
            <p>Job seekers can browse jobs, search by role or location, view detailed job information, and apply directly through the platform after logging in with a candidate account. Behind the scenes, admins can manage employers, jobs, applications, payments, and posting credits while keeping listings current with automatic 30-day expiration after approval.</p>
          </div>
        </div>
      </section>
      {/* End About Section Three */}

      {/* Call To Action Two */}
      <section className="call-to-action-two" style={{ backgroundImage: "url(/images/background/1.jpg)" }}>
        <div className="auto-container">
          <div className="sec-title light text-center">
            <h2>Find Talent Or Discover Your Next Role</h2>
            <div className="text">Epic-Jobs supports paid employer listings, direct applications, and simple job discovery for every visitor.</div>
          </div>

          <div className="btn-box">
            <Link to="/jobs" className="theme-btn btn-style-three">Browse Jobs</Link>
            <Link to="/pricing" className="theme-btn btn-style-two">View Pricing</Link>
          </div>
        </div>
      </section>
      {/* End Call To Action */}

      {/* Testimonial Section Two */}
      <section className="testimonial-section-two">
        <div className="container-fluid">
          <div className="sec-title text-center">
            <h2>Trusted By Hiring Teams And Applicants</h2>
            <div className="text">A focused platform for posting jobs, managing applicants, and helping candidates apply faster.</div>
          </div>

          <div className="carousel-outer">
            <div className="row">
              {testimonials.map((item) => (
                <div className="col-lg-4 col-md-6 col-sm-12" key={item.id}>
                  <div className="testimonial-block-two">
                    <div className="inner-box">
                      <div className="thumb"><img src={item.image} alt={item.name} /></div>
                      <h4 className="title">{item.title}</h4>
                      <div className="text">{item.text}</div>
                      <div className="info-box">
                        <h4 className="name">{item.name}</h4>
                        <span className="designation">{item.designation}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* End Testimonial Section */}

      {/* Work Section */}
      <section className="work-section style-two">
        <div className="auto-container">
          <div className="sec-title text-center">
            <h2>How It Works?</h2>
            <div className="text">A clear flow for employers, job seekers, and admins</div>
          </div>

          <div className="row">
            {workItems.map((item) => (
              <div className="work-block col-lg-4 col-md-6 col-sm-12" key={item.id}>
                <div className="inner-box">
                  <figure className="image"><img src={item.image} alt="" /></figure>
                  <h5>{item.title}</h5>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* End Work Section */}

      {/* Clients Section */}
      <section className="clients-section">
        <div className="sponsors-outer">
          <Swiper
            className="sponsors-carousel owl-carousel owl-theme"
            modules={[Autoplay]}
            tag="ul"
            spaceBetween={20}
            slidesPerView={2}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            breakpoints={{
              576: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              992: { slidesPerView: 5 },
              1200: { slidesPerView: 6 },
            }}
          >
            {clientLogos.map((logo) => (
              <SwiperSlide tag="li" className="slide-item" key={logo.id}>
                <figure className="image-box">
                  <img src={logo.src} alt="" />
                </figure>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {/* End Clients Section */}
    </>
  );
};

export default About;
